import { Reducer } from 'redux'
import { createFilter } from 'redux-persist-transform-filter'

import { GeneralState, GeneralActionTypes } from './types'

export const FILTER_PERSISTOR = createFilter(
  'general',
  null,
  ['collapsedSide'],
  'whitelist'
)

const INITIAL_STATE: GeneralState = {
  collapsedSide: true
}

const reducer: Reducer<GeneralState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case GeneralActionTypes.TOGGLE_SIDE:
      return { ...state, collapsedSide: !state.collapsedSide }
    default:
      return state
  }
}

export default reducer
